import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Select from '../../elements/Select'
import labels from '../../../configuration/labels'

import { setCategory } from '../../../redux/actions/setFilters'

const CategoryFilter = () => {
  const eventsData = useSelector(state => state.eventsData)
  const activeCategory = useSelector(state => state.filtersData.category)
  const dispatch = useDispatch()

  const handleCategoryChange = e => {
    dispatch(setCategory(e.target.value))
  }

  let categories = null

  if (eventsData && eventsData.data && eventsData.data.categories) {
    categories = eventsData.data.categories
  }

  return (
    <div className="flow-events__filters-categories">
      <Select
        defaultOption={{ label: 'All', value: '' }}
        value={activeCategory}
        label={labels.findAnEvent}
        name="category"
        options={categories}
        onChangeEvent={handleCategoryChange}
      />
    </div>
  )
}

export default CategoryFilter
